export default __webpack_public_path__ + "static/media/calendario.2dbd8aec.svg";